/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const InteractionIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Interaction',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m5.19141,11.32617c-.09473,0-.19141-.01758-.28467-.05664-2.26562-.93066-3.65381-3.19824-3.45508-5.6416C1.70264,2.5459,4.40771.24121,7.49512.49512c3.08105.25098,5.38379,2.96191,5.13281,6.04297-.0332.41309-.3877.72461-.80859.68652-.4126-.0332-.72021-.39551-.68652-.80762.18408-2.25781-1.50293-4.24316-3.75977-4.42773-2.25-.1748-4.24219,1.50391-4.42627,3.75977-.14551,1.79004.87109,3.45117,2.53027,4.13379.3833.15723.56592.5957.40869.97852-.11914.29004-.39893.46484-.69434.46484Z"
      fill="currentColor"
    />
    <path
      d="m13.58545,18.79102c-1.71143,0-3.36816-.67871-4.69873-1.22266l-.34912-.14258c-.57861-.23438-1.05322-.41602-1.44434-.56641-1.29932-.49707-1.89209-.72461-2.26953-1.42773-.48096-.89844-.10498-2.11523.80518-2.60352.69629-.37402,1.25732-.2666,3.21582.31348l-2.52734-4.70703c-.16455-.30566-.36914-.6875-.42725-1.14453-.09326-.73047.26465-1.4209.93359-1.80078.68115-.38672,1.50146-.33789,2.09131.12305.36572.28711.56982.66406.73389.96777l1.35596,2.51758c1.26709-.67871,3-1.11914,4.46484-.70312,1.11523.31738,1.95215,1.08496,2.4209,2.2207.55859,1.35449,2.2583,5.47461-1.71289,7.55566-.85449.44824-1.73047.62012-2.59229.62012Zm-7.07324-4.67285c-.07617,0-.13379.00977-.17383.03125-.18848.10156-.2876.39648-.19238.57324.10791.20117.44238.33789,1.48389.73633.39844.15234.88135.33789,1.4707.57617l.35449.14453c1.82373.74707,4.09277,1.67676,6.02637.66309s2.23975-2.70508,1.02246-5.65527c-.29541-.71582-.76807-1.15723-1.44482-1.34961-1.23291-.35547-2.89404.19922-3.89795.9248-.17529.12598-.39746.17285-.60693.12207-.21045-.04785-.39014-.18457-.49219-.375l-1.7334-3.21777c-.10742-.19922-.21924-.40527-.33936-.5-.13184-.10156-.31152-.0625-.4248.00195-.07861.04395-.20703.14355-.18604.30664.02295.18262.14355.40723.26025.625l3.38086,6.2959c.14355.2666.1123.59277-.0791.82812-.19092.23535-.50586.33301-.79492.24512l-1.0127-.30176c-1.45459-.43555-2.25586-.6748-2.62061-.6748Z"
      fill="currentColor"
    />
  </svg>`;
};
